import MapsModule from "../modules/maps";
import SliderModule from "../modules/slider";

$(document).ready(() => {
    var collapsibleClicked = false;
    var animating = false;

    $('#collapsible-gradient-box').on('click', () => {
        hideCollapsible();
    });

    var sliderModule = new SliderModule(".slider");
    sliderModule.init();

    $(window).on("load resize", function (e) {
        if ($(this).width() > 480 && animating === false) return hideCollapsible();

        const length = $('#p-anlaeg-content-text').text().length;
        if (length > 600 && collapsibleClicked === false) {
            showCollapsible();
            collapsibleClicked = true;
        }
    });

    const hideCollapsible = () => {
        if ($("#collapsible-gradient-box").hasClass('collapsible-gradient-hide') === true) return;

        animating = true;
        $("#collapsible-gradient-box").animate({
            opacity: 0,
            margin: 0,
            height: "toggle"
        }, 1000, function () {
            
        });

        $("#p-anlaeg-content-text").animate({
            maxHeight: 1000
        }, 1000, function () {
            $('#collapsible-gradient-box').removeClass('collapsible-gradient-show').addClass('collapsible-gradient-hide');
            $('#p-anlaeg-content-text').removeClass('collapsible-shown').addClass('collapsible-hidden');
            animating = false;
        });
    };

    const showCollapsible = () => {
        $('#collapsible-gradient-box').fadeIn();
        $('#collapsible-gradient-box').removeClass('collapsible-gradient-hide').addClass('collapsible-gradient-show');
        $('#p-anlaeg-content-text').removeClass('collapsible-hidden').addClass('collapsible-shown');
    }
});

window.initMap = () => {
    const lat: number = +$('#Content_Latitude').val();
    const lng: number = +$('#Content_Longitude').val();
    var mapsModule = new MapsModule("map",
        {
            centerLat: lat,
            centerLng: lng,
            mapTypeControl: false,
            zoom: 16,
            fullscreenControl: false
});

    mapsModule.addMarker(1, lat, lng, "");
}


// WEBPACK FOOTER //
// ./Content/scripts/pages/panlaeg.ts